import axios from "axios";

// Ionic
import {
  IonLabel,
  IonItem,
  IonInput,
  IonCheckbox,
  useIonToast,
  IonList,
  IonRadioGroup,
  IonRadio,
  IonButton,
  IonSelect,
  IonSelectOption,
  IonGrid,
  IonRow,
  IonCol,
} from "@ionic/react";
import UserService from "../../Context/user.service";
import React from "react";

//VARs
const REGISTER_URL =
  "/api/?action=update_profile";

function Profile(props) {

  var vehicle_type_items = [
    "Reisemobil",
    "XXL-Reisemobil",
    "Campervan",
    "Caravan-Gespann",
  ];
  var vehicle_brand_items = [
    "Adria",
    "Ahorn",
    "Benimar",
    "Bürstner",
    "Carado",
    "Caravelair",
    "Carthago",
    "Challenger",
    "Chausson",
    "Concorde",
    "Dethleffs",
    "Eriba",
    "Etrusco",
    "Eura Mobil",
    "Fendt Caravan",
    "Ford Nugget",
    "Forster",
    "Frankia",
    "Hobby",
    "Hymer",
    "Kabe",
    "Knaus",
    "Laika",
    "LMC",
    "Malibu",
    "Morelo",
    "Niesmann+Bischoff",
    "Phoenix",
    "Pilote",
    "Pössl",
    "Rapido",
    "Sterckeman",
    "Sunlight",
    "Tabbert",
    "VW",
    "Weinsberg",
    "Westfalia"
  ];
  var vehicle_length_items = ["Bis 6 m", "Bis 8 m", "Bis 10 m", "Über 10 m "];
  var crew_items = ["Paar", "Familie", "Alleinreisend", "Mit Hund"];
  var interests_items = [
    "Genuss",
    "Wellness & Gesundheit",
    "Kultur & Geschichte",
    "Schwimmen/Baden",
    "Sport und Spaß",
    "Naturnah übernachten",
  ];

  const [present, dismiss] = useIonToast();

  if (typeof props.user.interests !== "undefined") {
    setTimeout(function () {
      var multi = document.getElementById("interests");
      multi.value = props.user.interests;

    }, 0);
  }

  if (typeof props.user.crew !== "undefined" && props.user.crew != "") {

    setTimeout(function () {
      props.user.crew = props.user.crew.split(",");
      var crewitems = document.querySelectorAll('.crew-item');
      Array.prototype.forEach.call(crewitems, function (crewitem) {
        console.log(props.user.crew);
        props.user.crew.forEach(function (cr) {
          if(crewitem.value == cr) {
            document.querySelector(".crew-item[value='"+cr+"']").setAttribute("checked",true);
          }
        })
      });

    }, 50);


  }


  const handleSave = async (e) => {
    e.preventDefault();

    var user = props.user;

    // overwrite data
    if (
      typeof document.querySelector(
        "ion-radio[name='vehicle_type'].radio-checked"
      ) !== "undefined" &&
      document.querySelector("ion-radio[name='vehicle_type'].radio-checked") !==
        null
    ) {
      user.vehicle_type = document.querySelector(
        "ion-radio[name='vehicle_type'].radio-checked"
      ).value;
    }
    user.vehicle_model = document.querySelector("[name='vehicle_model']").value;
    user.vehicle_brand = document.querySelector("[name='vehicle_brand']").value;
    if (
      typeof document.querySelector(
        "ion-radio[name='vehicle_length'].radio-checked"
      ) !== "undefined" &&
      document.querySelector(
        "ion-radio[name='vehicle_length'].radio-checked"
      ) !== null
    ) {
      user.vehicle_length = document.querySelector(
        "[name='vehicle_length'].radio-checked"
      ).value;
    }
/*    if (
      typeof document.querySelector("ion-radio[name='crew'].radio-checked") !==
        "undefined" &&
      document.querySelector("ion-radio[name='crew'].radio-checked") !== null
    ) {
      user.crew = document.querySelector(
        "ion-radio[name='crew'].radio-checked"
      ).value;
    }*/



    var crewitems = document.querySelectorAll('.crew-item');
    var crewsave = [];
    Array.prototype.forEach.call(crewitems, function (crewitem) {
        if(crewitem.getAttribute("aria-checked")=="true") {
          crewsave.push(crewitem.value);
        }
    });

    user.crew = crewsave;
    user.more_vehiclebrand = document.querySelector("[name='more_vehiclebrand']").value
    user.age = document.querySelector("[name='age']").value;
    user.interests = document.querySelector("[name='interests']").value;
    if (typeof props.user._id !== "undefined") {
      user._id = props.user._id;
    }
    var userParm = new URLSearchParams(user).toString();
    userParm += "&token=" + props.token;
    try {
      const response = await axios.post(REGISTER_URL + "&" + userParm, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
      });

      present({
        /*
        buttons: [{  text: 'OK', handler: () => dismiss() }],
*/
        message: "Ihre Daten wurden erfolgreich gespeichert. ",
        duration: 3000,
        onDidDismiss: () => console.log("dismissed"),
        onWillDismiss: () => console.log("will dismiss"),
      });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="">
      <IonGrid className="content__margin ">
        <IonRow>
          <IonCol
            size="12"
            size-lg="9"
            size-xl="7"
            className="profile__wrapper"
          >
            <h2>Profil-Einstellungen</h2>
            <br />
            <h3>Mein Fahrzeug:</h3>

            <IonList className="profile__list">
              <IonRadioGroup value={props.user.vehicle_type}>
                <h5>Fahrzeug-Typ</h5>
                {vehicle_type_items.map((item, index) => {
                  return (
                    <>
                      <IonItem key={item} className="profile__item">
                        <IonLabel>{item}</IonLabel>
                        <IonRadio
                          name="vehicle_type"
                          value={item}
                          className="profile__radio"
                        ></IonRadio>
                      </IonItem>
                    </>
                  );
                })}
              </IonRadioGroup>
              <br />

              <br />
              <h5>Fahrzeug Marke</h5>

              <IonItem className="profile__item">
                <IonLabel>Marke wählen</IonLabel>
                <IonSelect
                  name="vehicle_brand"
                  value={props.user.vehicle_brand}
                >
                  {vehicle_brand_items.map((item, index) => {
                    return (
                      <IonSelectOption selected value={item}>
                        {item}
                      </IonSelectOption>
                    );
                  })}
                </IonSelect>
              </IonItem>
              <IonItem className="profile__item__text">
                <IonInput
                  name="more_vehiclebrand"
                  value={props.user.more_vehiclebrand}
                  placeholder="Sonstige Marke"
                ></IonInput>
              </IonItem>
              <p className="profile__modell">Modell</p>
              <IonItem className="profile__item__text profile__modell__input">
                <IonInput
                  name="vehicle_model"
                  value={props.user.vehicle_model}
                  placeholder="Modell eingeben"
                ></IonInput>
              </IonItem>

              <br />
              <h5>Fahrzeuglänge</h5>
              <IonRadioGroup value={props.user.vehicle_length}>
                {vehicle_length_items.map((item, index) => {
                  return (
                    <>
                      <IonItem className="profile__item">
                        <IonLabel>{item}</IonLabel>
                        <IonRadio name="vehicle_length" value={item}></IonRadio>
                      </IonItem>
                    </>
                  );
                })}
              </IonRadioGroup>
            </IonList>
            <br />
            <h3>Persönliche Angaben:</h3>
            <p>
              Mit den Angaben zu Deinem Reiseverhalten und Deinen Interessen
              kannst Du die Stellplatzsuche beeinflussen. Die Stellplätze, die
              Du zu Deinen Angaben passen, werden entsprechend in der
              Stellplatz-Trefferliste gekennzeichnet.
            </p>

            <IonList className="profile__list">
              <IonRadioGroup value={props.user.crew}>
                <h5>Reisecrew</h5>
                {crew_items.map((item, index) => {

                    return (
                      <>
                        <IonItem key={item} className="profile__item">
                          <IonLabel>{item}</IonLabel>
                          <IonCheckbox class="crew-item" name="crew" value={item}></IonCheckbox>

{/*                          {(function () {
                            if (props.activeFilter.typePitch === true) {
                              return (
                                  <IonCheckbox checked name="crew" value={item}></IonCheckbox>

                              );
                            } else {
                              return (
                                  <IonCheckbox name="crew" value={item}></IonCheckbox>

                              );
                            }
                          })()}*/}


                        </IonItem>
                      </>
                    );
                })}
              </IonRadioGroup>

              <br />
              <h5>Interessen</h5>

              <IonItem className="profile__item">
                <IonLabel>Interessen wählen</IonLabel>

                <IonSelect
                  id="interests"
                  name="interests"
                  placeholder="Interessen wählen"
                  multiple="true"
                >
                  {interests_items.map((item, index) => {
                    return (
                      <>
                        <IonSelectOption value={item}>{item}</IonSelectOption>
                      </>
                    );
                  })}
                </IonSelect>
              </IonItem>

              {/*<IonItem className="profile__item__text">
                <IonInput
                  name="more_interests"
                  value={props.user.more_interests}
                  placeholder="Sonstige Interessen"
                ></IonInput>
              </IonItem>*/}
              <br />
              <h5>Altersangabe</h5>
              <IonItem className="profile__item__text">
                <IonInput
                  name="age"
                  value={props.user.age}
                  placeholder="xx Jahre"
                ></IonInput>
              </IonItem>
              <br />
            

              <IonButton onClick={handleSave}>Daten speichern</IonButton>
              {/*
        <button onClick={handleSave}>Daten speichern</button>
*/}
            </IonList>
          </IonCol>
        </IonRow>
      </IonGrid>
    </div>
  );
}

export default Profile;
